import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";

export const bettingCompetitor = z.object({
  id: z.string(),
  abbreviation: z.string().nullish(),
  iconUri: z.string().nullish(),
  name: z.string(),
  nationality: z.string().nullish(),
});

export type BettingCompetitor = zInfer<typeof bettingCompetitor>;
